document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.faq-question').forEach(question => {
    const toggleAnswer = () => {
    const answer = question.nextElementSibling;
    const icon = question.querySelector('.faq-icon');
    const isOpen = answer.classList.toggle('open');

    question.setAttribute('aria-expanded', isOpen);
    icon.textContent = isOpen ? '–' : '+';
    answer.style.maxHeight = isOpen ? answer.scrollHeight + "px" : null;

    // 🔽 Tracking uniquement à l'ouverture
    if (isOpen && typeof _paq !== 'undefined') {
      _paq.push([
        'trackEvent',
        'FAQ',
        question.dataset.questionLabel || question.textContent.trim(),
        window.location.href
      ]);
    }
  };


    question.addEventListener('click', toggleAnswer);

    question.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        toggleAnswer();
      }
    });
  });

  // Si une FAQ est marquée .opened, ouvrir la première réponse
  const openedFaq = document.querySelector('.faq.opened');
  if (openedFaq) {
    const firstQuestion = openedFaq.querySelector('.faq-question');
    const firstAnswer = openedFaq.querySelector('.faq-answer');
    const firstIcon = openedFaq.querySelector('.faq-icon');
    if (firstAnswer) {
      firstAnswer.classList.add('open');
      firstAnswer.style.maxHeight = firstAnswer.scrollHeight + "px";
    }
    if (firstIcon) {
      firstIcon.textContent = '–';
    }
    if (firstQuestion) {
      firstQuestion.setAttribute('aria-expanded', 'true');
    }
  }
});